// @flow

type State = {|
  paramToChange: string,
  toReplace: string,
  replaceWith: string,
  isLoading: boolean,
  paramToChangeErrors: Array<string>,
  toReplaceErrors: Array<string>,
  replaceWithErrors: Array<string>
|}

type PatchAction = {|
  +type: 'DESCRIPTION_URL_FORM.PATCH',
  +state: $Shape<State>
|}

type Action = PatchAction

export type { State }

const initialState: State = {
  paramToChange: 'description',
  toReplace: '',
  replaceWith: '',
  isLoading: false,
  paramToChangeErrors: [],
  toReplaceErrors: [],
  replaceWithErrors: []
}

export function patch(diff: $Shape<State>): Action {
  return {
    type: 'DESCRIPTION_URL_FORM.PATCH',
    state: diff
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'DESCRIPTION_URL_FORM.PATCH': {
      return { ...state, ...action.state }
    }
    default:
      return state
  }
}
